/**
 * Disable zoom modal on mobile devices
 * Prevents zoom lightbox from opening on small screens
 */
(function() {
  'use strict';

  if (window.innerWidth >= 750) return;

  document.querySelectorAll('[data-zoom-image]').forEach(function(img) {
    img.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }, true);
  });
})();
